(function () {
  document.addEventListener('submit', function (event) {
    const form = event.target.closest('form[action*="/search"]');

    if (!form) return;

    const input = form.querySelector('input[name="q"]');

    if (!input) return;

    const searchTerm = input.value
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ');

    const neeDohTerms = [
      'nee doh',
      'nee do',
      'needoh',
      'nee-doh'
    ];

    if (neeDohTerms.includes(searchTerm)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      window.location.href = '/search?q=tag%3Asquishy';
    }
  }, true);
})();